import React from 'react';
import { Typography, Avatar } from 'antd';
import styled from 'styled-components';

const { Text } = Typography;

const ChatContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-height: 400px;
  overflow-y: auto;
  padding: 16px;
  background: #f5f5f5;
  border-radius: 8px;
`;

const MessageContainer = styled.div`
  display: flex;
  gap: 12px;
  align-items: flex-start;
`;

const MessageBubble = styled.div`
  background: ${props => (props.$isCurrentUser ? '#1890ff' : '#fff')};
  color: ${props => (props.$isCurrentUser ? '#fff' : 'rgba(0, 0, 0, 0.85)')};
  padding: 8px 12px;
  border-radius: 12px;
  max-width: 80%;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
`;

const TimeStamp = styled(Text)`
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
  margin-top: 4px;
  display: block;
`;

function ChatBox({ comments = [], currentUserId }) {
  return (
    <ChatContainer>
      {comments.map(comment => {
        const isCurrentUser = comment.user_id === currentUserId;
        return (
          <MessageContainer
            key={comment.id}
            style={{
              flexDirection: isCurrentUser ? 'row-reverse' : 'row',
            }}
          >
            <Avatar
              style={{
                backgroundColor: isCurrentUser ? '#1890ff' : '#f56a00',
              }}
            >
              {isCurrentUser ? 'You' : 'U'}
            </Avatar>
            <div>
              <MessageBubble $isCurrentUser={isCurrentUser}>{comment.comment}</MessageBubble>
              <TimeStamp>{new Date(comment.created_at).toLocaleString()}</TimeStamp>
            </div>
          </MessageContainer>
        );
      })}
    </ChatContainer>
  );
}

export default ChatBox;
